export default __webpack_public_path__ + "static/media/temi.2b89fd5b.jpg";